/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CompanyView from './company-view';
import { AdminService } from '../../services/requests';

const CompanyContainer = (props) => {
  const [loading, setLoading] = useState(false);
  const [companyData, setCompanyData] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [companyСastingsLoading, setCompanyСastingsLoading] = useState(false);
  const [companyCastings, setCompanyCastings] = useState();

  const getCompanyData = async () => {
    setLoading(true);
    try {
      const res = await AdminService.getCompany(props.history.location.hash.replace('#', ''));

      if (res) {
        setCompanyData(res);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const getCompanyCastings = async () => {
    setCompanyСastingsLoading(true);
    try {
      const res = await AdminService.getCastingsByCompanyId(props.history.location.hash.replace('#', ''));

      if (res) {
        setCompanyCastings(res);
        setCompanyСastingsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setCompanyСastingsLoading(true);
    }
  };

  const refreshAction = () => {
    if (activeTab === 0) {
      getCompanyData();
    }
    if (activeTab === 1) {
      getCompanyCastings();
    }
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  useEffect(() => {
    if (activeTab === 1 && companyCastings === undefined) {
      getCompanyCastings();
    }
  }, [activeTab]);

  return (
    <CompanyView
      loading={loading}
      companyData={companyData}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      refreshAction={refreshAction}
      history={props.history}
      companyСastingsLoading={companyСastingsLoading}
      companyCastings={companyCastings}
      categories={props.categories}
    />
  );
};

CompanyContainer.propTypes = {
  history: PropTypes.object,
  categories: PropTypes.object,
};
CompanyContainer.defaultProps = {
  history: {},
  categories: {},
};

const mapStateToProps = (state) => ({
  categories: state.categories,
});

export default connect(
  mapStateToProps,
  null,
)(CompanyContainer);
